export { default as deactivatedStatusIcon } from './deactivated-status-icon.svg';
export { default as registeredStatusIcon } from './registered-status-icon.svg';
export { default as publishedStatusIcon } from './published-status-icon.svg';
export { default as copyIcon } from './copy-icon.svg';
export { default as arrowRight } from './arrow-right.svg';
export { default as welcomeBgIcon } from './welcome-bg-icon.svg';
export { default as greenwayHealth } from './greenway-health.svg';
export { default as facebookLogo } from './facebook-logo.svg';
export { default as twitterLogo } from './twitter-logo.svg';
export { default as linkedInLogo } from './linkedin-logo.svg';
export { default as instagramLogo } from './instagram-logo.svg';
export { default as youtubeLogo } from './youtube-logo.svg';
export { default as greenwayLogo } from './greenway-logo.svg';
export { default as pcMonitorPink } from './pc-monitor-pink.svg';
export { default as pcMonitorGreen } from './pc-monitor-green.svg';
export { default as pcMonitorPurple } from './pc-monitor-purple.svg';
export { default as developerPlatformText } from './developer-platform-text.svg';
export { default as logout } from './logout.svg';
export { default as user } from './user.svg';
export { default as pencil } from './pencil.svg';
export { default as information } from './information.svg';
export { default as magnifyingGlass } from './magnifying-glass.svg'
export { default as errorRedIcon } from './error-red-icon.svg'
export { default as warningIcon } from './warning-icon.svg'